import React, { useState, useCallback } from "react";
import { DeleteConfirmationDialog } from "../components";

export interface IUseDeleteConfirmationProps {
    title: string;
    message: string;
    onDeleteConfirm: (data: any) => void;
}

export default function useDeleteConfirmation(props: IUseDeleteConfirmationProps) {
    const [showDelete, setShowDelete] = useState<boolean>(false);
    const [data, setData] = useState<any>(null);

    // Confirm delete...
    const handleDeleteConfirmation = () => {
        setShowDelete(false);
        props.onDeleteConfirm(data);
    };

    // Cancel delete...
    const handleDeleteConfirmationClose = () => {
        setShowDelete(false);
    };

    // Delete confirmation dialog...
    const deleteConfirmationDialog = <DeleteConfirmationDialog 
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onDeleteClick={handleDeleteConfirmation}
        onCancelClick={handleDeleteConfirmationClose}
        title={props.title}
        message={props.message}
    />;

    const setShowDeleteConfirmation = useCallback((show: boolean, data: any = null) => {
        setShowDelete(show);
        setData(data);
    }, [setShowDelete, setData]);

    return {
        setShowDeleteConfirmation,
        deleteConfirmationDialog
    };
}